// extracted by mini-css-extract-plugin
module.exports = {"container":"e2ff468f85--container--1v552","close-btn":"e2ff468f85--close-btn--PnvcI","text":"e2ff468f85--text--1gYtR","add-btn":"e2ff468f85--add-btn--6qSa6"};